import { Outlet } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ChatWidget } from "@/components/ChatWidget";

export const PublicLayout = () => (
  <div className="min-h-screen bg-[#07080B]">
    <Navbar />
    <main className="pt-16 lg:pt-20"><Outlet /></main>
    <Footer />
    <ChatWidget />
  </div>
);
